export const SOLR_PART_NUMBER_KEY = 'itemPartNumber';
export const SOLR_IMAGE_KEY = 'thumbnail';
export const LUCID_PART_NUMBER_KEY = 'partNumber';
export const LUCID_IMAGE_KEY = 'imageURL';
